import { render, staticRenderFns } from "./PositionsDiff.vue?vue&type=template&id=2b2f648d&"
import script from "./PositionsDiff.vue?vue&type=script&lang=js&"
export * from "./PositionsDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports